// Helpers de positionnement purs du dropdown leads (sans React, testables sous Vitest node).

export interface OffsetMeasurable {
  offsetTop: number;
  offsetLeft: number;
  offsetParent: OffsetMeasurable | null;
  offsetHeight: number;
  offsetWidth: number;
  clientWidth: number;
}

export interface DropdownCoords {
  offsetTop: number;
  offsetLeft: number;
  h: number;
  w: number;
}

function getPositionLeft(obj: OffsetMeasurable | null): number {
  if (!obj) return 0;
  let curleft = obj.offsetLeft;
  let parent = obj.offsetParent;
  while (parent) {
    curleft += parent.offsetLeft;
    parent = parent.offsetParent;
  }
  return curleft;
}

function getPositionTop(obj: OffsetMeasurable | null): number {
  if (!obj) return 0;
  let curtop = obj.offsetTop;
  let parent = obj.offsetParent;
  while (parent) {
    curtop += parent.offsetTop;
    parent = parent.offsetParent;
  }
  return curtop;
}

// Position (relative au document) + taille du bouton. Reprend le comportement historique de calculateCoords.
export function computeCoordsFromElement(
  el: OffsetMeasurable,
  additionalX?: unknown,
  additionalY: number = 0,
): DropdownCoords {
  return {
    offsetTop: getPositionTop(el) + additionalY,
    offsetLeft: additionalX
      ? getPositionLeft(el) -
        Number.parseInt(String(el.offsetParent?.clientWidth))
      : getPositionLeft(el),
    h: el.offsetHeight,
    w: el.offsetWidth,
  };
}

// Construit le `transform` CSS du modal. Le flip vers le haut n'est ajouté que si isOutBottom
// (évite l'ancien bug où `isOutBottom && translateY` injectait la chaîne "false").
export function buildDropdownModalTransform({
  h,
  w,
  isOut,
  isOutBottom,
}: {
  h: number;
  w: number;
  isOut?: boolean | null;
  isOutBottom?: boolean | null;
}): string {
  const baseTranslateY = `translateY(${h + 10}px)`;
  const translateX = `translateX(calc(-100% + ${w}px))`;
  const flipUp = `translateY(-100%)`;

  if (isOut || isOutBottom) {
    return `${baseTranslateY} ${translateX}${isOutBottom ? " " + flipUp : ""}`;
  }

  return `${baseTranslateY} ${translateX}`;
}
